export const mockData =
    {
        "52aa8ced88e4b5078c9d1aa370e8d746": [{
            "jobId": 78162367,
            "title": "设备技术管理",
            "jobKind": "2",
            "workYearShow": "应届",
            "eduLevelName": "硕士",
            "jobAddress": "昆明",
            "compLogo": "5d1efdf93fa7ce27b2acb17908u.png",
            "jobType": "2",
            "companyName": "云天化集团有限责任公司",
            "pcOuterLink": "https://www.liepin.com/job/1978162367.shtml",
            "h5OuterLink": "https://m.liepin.com/job/1978162367.shtml",
            "salary": "薪资面议",
            "jobTags": [
                "应届",
                "硕士",
                "5000-10000人",
                "化工",
                "国有企业"
            ]
        }],
        "6aa5d3acc46239694c57918e4bf91bb3": [{
            "jobId": 78044209,
            "title": "研究开发-氟化工（博士）",
            "jobKind": "2",
            "workYearShow": "应届",
            "eduLevelName": "硕士",
            "jobAddress": "昆明",
            "compLogo": "5d1efdf93fa7ce27b2acb17908u.png",
            "jobType": "2",
            "companyName": "云天化集团有限责任公司",
            "pcOuterLink": "https://www.liepin.com/job/1978044209.shtml",
            "h5OuterLink": "https://m.liepin.com/job/1978044209.shtml",
            "salary": "薪资面议",
            "jobTags": [
                "应届",
                "硕士",
                "5000-10000人",
                "化工",
                "国有企业"
            ]
        }]
    }

